import PropTypes from 'prop-types'
import map from 'lodash/map'
import {
  formatCurrency,
  formatDate,
  formatDecimal,
  formatMonthYear,
  formatMultiple,
  formatPercent,
} from '~/utils/helpers'
import DiscoverCardStat from './DiscoverCardStat'

export const statFormat = {
  date: (data) => formatDate(data),
  monthYear: (data) => formatMonthYear(data),
  currency: (data) => formatCurrency(data),
  percent: (data) => formatPercent(data),
  decimal: (data) => formatDecimal(data),
  multiple: (data) => formatMultiple(data),
}

export const DiscoverCardStats = ({ items }) => {
  // Helper function to split items into chunks of 8
  const chunkedItems = []
  for (let i = 0; i < items.length; i += 8) {
    chunkedItems.push(items.slice(i, i + 8))
  }

  return (
    <>
      {chunkedItems.map((chunk, index) => (
        <div key={index} className="discover-card-stat-container">
          {map(chunk, (item, idx) => (
            <DiscoverCardStat
              key={idx}
              title={item.title}
              data={item.data}
              format={item.format}
            />
          ))}
        </div>
      ))}
    </>
  )
}

DiscoverCardStats.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node,
      data: PropTypes.any,
      format: PropTypes.func,
    })
  ),
}
